import React from 'react';
import className from 'classnames';
import { get } from 'lodash';
import moment from 'moment';

import TableHeader from '../TableHeader';
import UserAvatar from '../UserAvatar';

const PostScoresList = ({
  postScores = [],
  offset = 0
}) => {

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Post Scores</h2>
        </div>
      </div>
      <div
        className={className('Table', {
          'Table--post-scores': true,
        })} style={{gridTemplateColumns: '0.5fr 0.5fr 1.5fr 0.5fr 1fr 1fr'}}
      >
        {(() => {
        const columnHeaders = [
          {
            label: 'Rank'
          },
          {
            label: 'Post ID'
          },
          {
            label: 'Breakdown'
          },
          {
            label: 'Score',
            className: 'Table__col--ta-c'
          },
          {
            label: 'Create At',
            className: 'Table__col--ta-c'
          },
          {
            label: 'Update At',
            className: 'Table__col--ta-c'
          }
        ]

        return (
          <div className='Table__row'>
            {columnHeaders.map((header, key) => (
              <TableHeader
                key={key}
                header={header}
              />
            ))}
          </div>
          )
        })()}
        {postScores.map((postScore, index) => (
          <div
            className='Table__row'
            key={postScore.id}
          >
            <div className='Table__col'>{index + 1 + (offset)}</div>
            <div className="Table__col">
              <a className='Table__a' href={`/${gon.currentProvider}/posts/${get(postScore, 'postId')}`} target='_blank'>
                {get(postScore, 'postId')}
              </a>
            </div>
            <div className='Table__col'>
              {
                Object.entries(get(postScore, 'breakdown')).map(([key, value]) => {
                  return <div key={`${postScore.id}-breakdown-${key}`}>{key}: {value}</div>
                })
              }
            </div>
            <div className='Table__col Table__col--ta-r'>{(+postScore.score).toLocaleString()}</div>
            <div
              className='Table__col Table__col--ta-c'
              dangerouslySetInnerHTML={
                {
                  __html: postScore.createdAt !== null ?
                    moment(postScore.createdAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div
              className='Table__col Table__col--ta-c'
              dangerouslySetInnerHTML={
                {
                  __html: postScore.updatedAt !== null ?
                    moment(postScore.updatedAt).format('YYYY-MM-DD HH:mm')
                  :
                    'N/A'
                }
              }
            />

          </div>

        ))}
      </div>
    </React.Fragment>
  )
}

export default PostScoresList
